import React from 'react'
import { mapProps } from 'recompose'
import FormTextField from './FormTextField'
import { FormTypeEnum } from './enum/formTypeEnum'
import FormTextFieldInline from './FormTextFieldInline'
import FieldsNombreRechercheForm from '../menu/components/FieldsNombreRechercheForm'
import { NumericFormat } from 'react-number-format'

// Wrapped component, we had to redefine functions because NumberFormat uses the same callbacks than the FormInput so we had to adapt them to FormInput
const WrappedFormInput = mapProps(
	(
		{
			reduxProps: {
				input: {
					onFocus,
					onBlur
				},
				...others
			},
			onChange,
			value
		}: any
	) => {
		return {
			input: {
				onChange,
				onFocus,
				onBlur: () => {
					onBlur(undefined)
				},
				value
			},
			...others
		}
	}
)(FormTextField)

const WrappedFormInlineInput = mapProps(
	(
		{
			reduxProps: {
				input: {
					onFocus,
					onBlur
				},
				...others
			},
			onChange,
			value
		}: any
	) => {
		return {
			input: {
				onChange,
				onFocus,
				onBlur: () => {
					onBlur(undefined)
				},
				value
			},
			...others
		}
	}
)(FormTextFieldInline)

const WrappedFormNombreRechercheInput = mapProps(
	(
		{
			reduxProps: {
				input: {
					onFocus,
					onBlur
				},
				...others
			},
			onChange,
			value
		}: any
	) => {
		return {
			input: {
				onChange,
				onFocus,
				onBlur: () => {
					onBlur(undefined)
				},
				value
			},
			...others
		}
	}
)(FieldsNombreRechercheForm)

// Component used to format entered number with thousand separator
const FormNumberFormatField = (reduxFormProps: any) => {
	let thousandSeparator = ''
	if (!('thousandSeparator' in reduxFormProps)) {
		thousandSeparator = ' '
	} else {
		thousandSeparator = reduxFormProps.thousandSeparator
	}

	const gestionCustomInput = () => {
		if (reduxFormProps.formType === FormTypeEnum.dossier) {
			return WrappedFormInlineInput
		}

		if (reduxFormProps.formType === FormTypeEnum.nombreRecherche) {
			return WrappedFormNombreRechercheInput
		}

		return WrappedFormInput
	}

	return (
		<NumericFormat
			customInput={gestionCustomInput()}
			isNumericString
			onValueChange={(values) => {
				reduxFormProps.input.onChange(thousandSeparator === ' ' ? values.floatValue : values.formattedValue)
			}}
			thousandSeparator={thousandSeparator}
			reduxProps={reduxFormProps}
			value={reduxFormProps.input.value}
			allowNegative={reduxFormProps.allowNegative}
			decimalScale={reduxFormProps.decimalScale}
			suffix={reduxFormProps.suffix}
			endAnorment={reduxFormProps.endAnorment}
		/>
	)
}

export default FormNumberFormatField
